import React from 'react';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { MfsLanguage } from '../../interfaces/MfsLanguage';
import { Rater } from '../../interfaces/Rater';
import { useTranslation } from 'react-i18next';
import { RaterStyles } from '../../styles/rater';

interface AddRaterFormProps {
  rater: Rater;
  isSearch: boolean;
  languages?: Array<MfsLanguage>;
  onInputChange(name: keyof Rater): (event: React.ChangeEvent<{ value: string }>) => void;
}

export const AddRaterForm = ({ rater, languages, onInputChange }: AddRaterFormProps): JSX.Element => {
  const { t } = useTranslation();
  const classes = RaterStyles();

  return (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        <>
          {/** Firstname */}
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <InputLabel htmlFor="firstName">
                  <b>{t('firstName')}</b>
                </InputLabel>
              </Grid>
              <Grid item xs={12} translate="no">
                <TextField
                  id="firstName"
                  type="text"
                  variant="outlined"
                  fullWidth
                  name="firstName"
                  autoComplete="text"
                  size="small"
                  value={rater.firstName}
                  error={rater.firstNameHelperText !== ''}
                  helperText={rater.firstNameHelperText !== '' ? t(`${rater.firstNameHelperText}`) : undefined}
                  placeholder={t('firstNamePlaceholder')}
                  onChange={onInputChange('firstName')}
                  onBlur={onInputChange('firstName')}
                  inputProps={{
                    'aria-label': t('firstName'),
                    maxLength: '100',
                    className: classes.bgWhite,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/** Lastname */}
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <InputLabel htmlFor="lastName">
                  <b>{t('lastName')}</b>
                </InputLabel>
              </Grid>
              <Grid item xs={12} translate="no">
                <TextField
                  id="lastName"
                  type="text"
                  variant="outlined"
                  fullWidth
                  name="lastName"
                  autoComplete="text"
                  size="small"
                  value={rater.lastName}
                  error={rater.lastNameHelperText !== ''}
                  helperText={rater.lastNameHelperText !== '' ? t(`${rater.lastNameHelperText}`) : undefined}
                  placeholder={t('lastNamePlaceholder')}
                  onChange={onInputChange('lastName')}
                  onBlur={onInputChange('lastName')}
                  inputProps={{
                    'aria-label': t('lastName'),
                    maxLength: '100',
                    className: classes.bgWhite,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/** Email */}
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <InputLabel htmlFor="email">
                  <b>{t('email')}</b>
                </InputLabel>
              </Grid>
              <Grid item xs={12} translate="no">
                <TextField
                  id="email"
                  type="text"
                  variant="outlined"
                  fullWidth
                  name="email"
                  autoComplete="text"
                  size="small"
                  value={rater.email}
                  error={rater.emailHelperText !== ''}
                  helperText={rater.emailHelperText !== '' ? t(`${rater.emailHelperText}`) : undefined}
                  placeholder={t('emailPlaceholder')}
                  onChange={onInputChange('email')}
                  onBlur={onInputChange('email')}
                  inputProps={{
                    'aria-label': t('email'),
                    maxLength: '100',
                    className: classes.bgWhite,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/** Language */}
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <InputLabel htmlFor="language">
                  <b>{t('language')}</b>
                </InputLabel>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="language"
                  select={true}
                  value={rater.language ? rater.language.toLowerCase() : '-1'}
                  disabled={false}
                  fullWidth
                  error={rater.languageHelperText !== ''}
                  helperText={rater.languageHelperText !== '' ? t(`${rater.languageHelperText}`) : undefined}
                  size="small"
                  onChange={onInputChange('language')}
                  variant="outlined"
                  InputProps={{
                    className: classes.bgWhite,
                    id: 'languageInput',
                  }}>
                  <MenuItem value="-1">{t('pleaseSelect')}</MenuItem>
                  {languages &&
                    languages.map((lang) => (
                      <MenuItem key={lang.locale} value={lang.locale && lang.locale.toLowerCase()}>
                        {lang.languageName}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
            </Grid>
          </Grid>
        </>
      </Grid>
    </Grid>
  );
};
